import React, { useEffect } from 'react';
import {
  useParams,
} from 'react-router-dom';
import startCase from 'lodash/startCase';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormViewSlot from '../../forms/FormViewSlot.jsx';

const PageViewSlot = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    req({
      url: `/api/site/view-slots/${_id}`,
    });
  }, [_id]);

  const breadcrumb = [
    { to: '../', children: 'Site' },
  ];

  return (
    <PageHttp res={res}>
      {(doc) => (
        <>
          <Header breadcrumb={breadcrumb}>
            {startCase(doc.key)}
          </Header>
          <FormViewSlot viewSlot={doc} />
        </>
      )}
    </PageHttp>
  );
};

export default PageViewSlot;
